import {useCustomQuery} from "~/query/queryClient";
import {queryHttp} from "~/query/queryHttp";
import {supplierBuQualificationsUrl} from "~/pages/supplier-360/services/supplier360Urls";
import type {BuQualification} from "~/pages/supplier-360/types/Supplier360Types";

/**
 * BU qualifications for one entity (`GET supplier_360/bu_qualification/?entity={id}&no_page=1`).
 * Returns a bare array — `no_page=1` disables pagination (§1). Used to join the Qualification
 * column onto business-unit-layer requirement rows (§3.7).
 */
export function useSupplierBuQualificationsQuery(entityId: number | undefined) {
    const url = supplierBuQualificationsUrl(entityId ?? 0);
    return useCustomQuery({
        queryKey: [url] as const,
        queryFn: async () => (await queryHttp.get<BuQualification[]>(url)).data,
        enabled: Boolean(entityId),
    });
}
